export const Roles = {
    ADMINISTRATOR: "Administrator",

    USER: "User",

    ADMIN:"Admin"

}